import { render, staticRenderFns } from "./PersonalArmamentoComponent.vue?vue&type=template&id=f24c8248"
import script from "./PersonalArmamentoComponent.vue?vue&type=script&lang=js"
export * from "./PersonalArmamentoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports